import cn from 'classnames'
import { Button, ButtonStyles, Typography } from '@grammarly/badger-ui'
import { composeUrl } from '../../../../../lib/utils/url'
import { useUserService } from '../../../../../lib/hooks'
import styles from './ctas.module.scss'
import { gnarSpec } from '../../../../../lib/tracking/gnar'
import { usePageInfo } from '../../../../../contexts/page-context'

const getCtaContent = (
  isAnonymous: boolean,
  isInPlanPagePlagiarismExperiment: boolean,
  isInPrecisePlagiarismReportExperiment: boolean
) => {
  if ((isAnonymous && isInPlanPagePlagiarismExperiment) || isInPrecisePlagiarismReportExperiment) {
    return <b>Get Grammarly</b>
  }

  return isAnonymous ? (
    <>
      <b>Get Grammarly</b>&nbsp;It&apos;s free
    </>
  ) : (
    <b>Get Grammarly Pro</b>
  )
}

type Placement = 'initialSide' | 'wallSide' | 'signupWall' | 'report'

interface AlreadyHaveAnAccountLinkProps {
  placement: Placement
  className?: string
}

export const AlreadyHaveAnAccountLink = (props: AlreadyHaveAnAccountLinkProps) => {
  const { className, placement } = props
  const signinUrl = composeUrl('signin', {})
  const { pageId, slug } = usePageInfo()
  const { isAnonymous } = useUserService().currentUser

  if (!isAnonymous) {
    return null
  }

  return (
    <Typography.C5 className={cn(styles.loginSupplement, className)} as="div">
      Already have an account?&nbsp;
      <a
        className={styles.loginLink}
        href={signinUrl}
        target="_blank"
        rel="noreferrer noopener"
        onClick={() => {
          void gnarSpec.plagiarismLoginLinkClick(pageId, slug, placement)
        }}
      >
        Log in
      </a>
    </Typography.C5>
  )
}

interface SignUpButtonProps {
  scaleUp?: boolean
  placement: Placement
  isForPlagiarismPlanPage: boolean
  isInPrecisePlagiarismReportExperiment?: boolean
  className?: string
}

export const SignUpButton = (props: SignUpButtonProps) => {
  const {
    scaleUp,
    placement,
    isForPlagiarismPlanPage,
    isInPrecisePlagiarismReportExperiment = false,
    className,
  } = props
  const { isAnonymous } = useUserService().currentUser
  const signupUrl = composeUrl('signup', {})
  const upgradeUrl = composeUrl('upgrade/pro', {})
  const { pageId, slug } = usePageInfo()

  return (
    <Button
      className={cn(
        ButtonStyles.GreenButtonWhiteText24,
        className,
        styles.ctaButton,
        scaleUp && styles.ctaButtonScaleUp
      )}
      as="a"
      href={isAnonymous ? signupUrl : upgradeUrl}
      onClick={() => {
        const ctaType = isAnonymous ? 'signup' : 'premium'
        void gnarSpec.reportSummaryCtaLinkClick(ctaType, pageId, slug, placement)
      }}
    >
      {getCtaContent(isAnonymous, isForPlagiarismPlanPage, isInPrecisePlagiarismReportExperiment)}
    </Button>
  )
}
